"use client";

import React from "react";
import { ArrowRight, TrendingUp, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowWeHelp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="how-we-help" className="bg-background py-24 lg:py-32 overflow-hidden" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="relative pl-6 sm:pl-10">
            {}
            <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-border/50 rounded-full overflow-hidden">
              <div className="w-full bg-primary transition-all duration-1500 ease-in-out" style={{
              height: isVisible ? "100%" : "0%"
            }} />
            </div>

            {}
            <div className={`relative rounded-3xl overflow-hidden aspect-[4/5] sm:aspect-[3/4] shadow-2xl transition-all duration-1000 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/uk_social_housing_development.png" alt="Modern UK Social Housing Development" className="w-full h-full object-cover" />
              {}
              <div className="absolute inset-0 bg-slate-900/20 mix-blend-overlay" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
            </div>

            {}
            <Card className={`absolute -bottom-8 -right-2 sm:-right-8 w-[calc(100%-3rem)] sm:w-80 bg-background/70 backdrop-blur-xl border-border/50 shadow-xl transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <CardHeader className="pb-2">
                <CardTitle className="text-xs font-bold tracking-widest text-muted-foreground uppercase flex items-center gap-2 font-default">
                  <TrendingUp className="w-4 h-4 text-chart-3" />
                  Social Impact
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-4xl sm:text-5xl font-bold text-chart-3 font-default mb-2">
                  12,500+
                </div>
                <p className="text-sm text-foreground font-sans leading-relaxed">
                  Affordable homes funded and developed across the United Kingdom.
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="flex flex-col justify-center pt-12 lg:pt-0">
            <div className={`transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-6 font-sans">
                <Home className="w-4 h-4" />
                <span>Our Mission</span>
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold font-default text-foreground mb-8 leading-tight">
                Building Wealth.<br />
                <span className="text-muted-foreground">Solving the Crisis.</span>
              </h2>
              
              <div className="space-y-6 mb-10">
                <p className="font-sans text-lg text-foreground leading-[1.8]">
                  We bridge the critical gap between institutional capital and the urgent need for affordable housing. Our innovative models deliver robust, risk-adjusted returns while directly addressing one of society's most pressing challenges.
                </p>
                <p className="font-sans text-lg text-muted-foreground leading-[1.8]">
                  By partnering with local authorities and established housing associations, we ensure that every investment creates lasting social value, empowering communities and fostering sustainable growth for generations to come.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" variant="outline" className="w-full sm:w-auto font-default">
                  <Link to="https://10percent-yield.com/investments/">View Case Studies</Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}